<template>
  <ChecklistBlockBase
    :buttonsPreset="'copy'"
    :buttonsData="editorMetadata.buttonsData"
    @commonAction="(action) => $emit('commonAction', action)"
  >
    <WhiteIQOS bodyClass="checklist-block-iqos-body">
      <template #title>
        <BaseIcon size="sm3" icon="check-square-bold" />  {{  $t('checklist_blocks.checklist.title') }}
      </template>

      <div class="checklist-block-iqos-body-block">
        <BaseTextInput v-model="block.title" size="md" :placeholder="$t('checklist_blocks.title_ph')" />
      </div>

      <div class="checklist-block-contents">
        <draggable class="the-checklist-block-list" :value="block.checklist.rows" @change="onRearrangeChange">
          <template v-for="(row, index) in block.checklist.rows">
            <div
              class="block-list-item"
              :class="{
                editing: editingIndex === index,
              }"
              @click="editingIndex = index"
              :key="index"
            >
              <BaseIcon size="sm2" icon="rearange" />
              <BaseTextInput
                size="md"
                v-model="row.text"
                :placeholder="$t('checklist_blocks.checklist.item_ph')"
                @enterPress="addItem"
                @blur="$emit('commonAction', 'update')"
                :ref="`row${index}`"
              />
              <BaseIconButton
                variant="ghost"
                icon="x"
                size="sm"
                @click="removeItem(index)"
                textColor="content-base-tertiary"
              />
            </div>
            <BaseDivider color="border-base-tertiary" :key="`div${index}`" />
          </template>
        </draggable>
        <div class="add-button-container">
          <BasePushButton
            @click="addItem"
            icon="plus"
            size="md"
            variant="ghost"
            textColor="content-base-secondary"
            class="bold"
          >
            {{  $t('checklist_blocks.checklist.btn_add') }}
          </BasePushButton>
        </div>
      </div>

      <template #footer>
        <BlockAssignOption @assigned="$emit('commonAction', 'update')" :optionsBlocks="editorMetadata.optionsBlocksAbove" :block="block" v-if="editorMetadata.canAssignOptions"/>
        <BaseDivider color="border-base-secondary" v-if="editorMetadata.canAssignOptions"/>
        <div class="checklist-block-iqos-footer long-options">
          <BaseBetaCheckbox v-model="block.checklist.must_complete_all">
            {{  $t('checklist_blocks.checklist.setting_required') }}
          </BaseBetaCheckbox>
          <BaseBetaCheckbox v-model="block.checklist.comment_required">
             {{  $t('checklist_blocks.checklist.setting_comment') }}
          </BaseBetaCheckbox>
          <!-- <BaseBetaCheckbox v-model="block.cached">
             {{  $t('checklist_blocks.checklist.setting_addable') }}
          </BaseBetaCheckbox> -->
        </div>
      </template>
    </WhiteIQOS>
  </ChecklistBlockBase>
</template>

<script>
import ChecklistBlockBase from "./ChecklistBlockBase.vue";
import BlockAssignOption from "../BlockAssignOption.vue"
import draggable from "vuedraggable";

export default {
  props: {
    block: Object,
    editorMetadata: Object
  },
  data() {
    return {
      editingIndex: null,
    };
  },
  methods: {
    addItem() {
      this.block.checklist.rows.push({
        text: null,
      });
      this.editingIndex = this.block.checklist.rows.length - 1;

      this.$nextTick(() => {
        this.$refs[`row${this.block.checklist.rows.length-1}`][0].getInputElement().focus();
      });
    },
    removeItem(index) {
      this.$delete(this.block.checklist.rows, index);
      this.editingIndex = null;
      this.$emit('commonAction', 'update');
    },
    onRearrangeChange(ev) {
      if (ev.moved) {
        const first = Math.round(ev.moved.oldIndex / 2);
        const second = Math.round(ev.moved.newIndex / 2);

        const tmp = this.block.checklist.rows[first];

        this.$delete(this.block.checklist.rows, first);
        this.block.checklist.rows.splice(second, 0, tmp);

        this.editingIndex = null;

        this.$emit('commonAction', 'update');
      }
    },
  },
  mounted() {
    if (this.block.checklist.rows.length == 1 && !this.block.checklist.rows[0].text) {
      this.editingIndex = 0;
    }
  },
  components: {
    ChecklistBlockBase,
    draggable,
    BlockAssignOption
  },
};
</script>

<style scoped>
.the-checklist-block-list {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
}

.block-list-item {
  display: flex;
  flex-direction: row;
  padding: 8px;
  column-gap: 8px;
  align-items: center;
}

.checklist-block-contents {
  display: flex;
  flex-direction: column;
  padding: 8px;
  padding-bottom: 16px;
  row-gap: 16px;
}

.block-list-item.editing {

}

.block-list-item:hover {
  background: var(--qrw-background-base-secondary);
}

.add-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.long-options {
  flex-direction: column;
  row-gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>
